import { render, staticRenderFns } from "./BaseCoverModal.vue?vue&type=template&id=1eba7ed8&scoped=true&lang=pug"
import script from "./BaseCoverModal.vue?vue&type=script&lang=js"
export * from "./BaseCoverModal.vue?vue&type=script&lang=js"
import style0 from "./BaseCoverModal.vue?vue&type=style&index=0&id=1eba7ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eba7ed8",
  null
  
)

export default component.exports